import { Star, Award, Users, Clock, Shield, ThumbsUp } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";
import { motion } from "framer-motion";

const reasons = [
  { icon: Star, title: "Doświadczenie", description: "Ponad 999 występów dla największych firm w Polsce", stat: "999+" },
  { icon: Award, title: "Profesjonalizm", description: "Zawodowi komicy z 27-letnim stażem scenicznym", stat: "27+ lat" },
  { icon: Users, title: "Dostosowanie", description: "Program dopasowany do charakteru i potrzeb Twojej firmy", stat: "100%" },
  { icon: Clock, title: "Punktualność", description: "Zawsze na czas, zawsze przygotowani", stat: "24/7" },
  { icon: Shield, title: "Zaufanie", description: "Zaufało nam setki firm z całej Polski - wracają do nas regularnie", stat: "100%" },
  { icon: ThumbsUp, title: "Rekomendacje", description: "Setki pozytywnych opinii od zadowolonych klientów", stat: "100%" },
];

export const WhyUs = () => {
  return (
    <section id="dlaczego-my" className="py-24 md:py-32 bg-gradient-to-b from-gray-50/50 to-white">
      <div className="container">
        <ScrollReveal>
          <h2 className="section-heading">
            Dlaczego <span className="gradient-text">my</span>?
          </h2>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, i) => {
            const Icon = reason.icon;
            return (
              <ScrollReveal key={reason.title} delay={i * 0.08}>
                <div className="modern-card group h-full">
                  <div className="flex items-start justify-between mb-4">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-brand-purple to-brand-magenta flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <span className="text-2xl font-montserrat font-extrabold gradient-text">{reason.stat}</span>
                  </div>
                  <h3 className="text-lg font-montserrat font-bold mb-2 text-primary">{reason.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{reason.description}</p>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
